const TextInput = ({ ...rest }) => {
  return <input className="text-input" {...rest} />;
};

export default TextInput;
